<div class="trips-container">
  <app-page-header title="Fishing Trips"></app-page-header>

  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>

  <div class="table-scroll">
  <table mat-table [dataSource]="dataSource" *ngIf="!isLoading" aria-label="Fishing trips">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Trip</th>
      <td mat-cell *matCellDef="let row">
        <span class="trip-name">{{ row.name || ('Trip #' + row.trip_id) }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="start_time">
      <th mat-header-cell *matHeaderCellDef>Started</th>
      <td mat-cell *matCellDef="let row">{{ row.start_time | date:'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef>Duration</th>
      <td mat-cell *matCellDef="let row">{{ formatDuration(row.duration_minutes) }}</td>
    </ng-container>

    <ng-container matColumnDef="total_catches">
      <th mat-header-cell *matHeaderCellDef>Catches</th>
      <td mat-cell *matCellDef="let row">{{ row.total_catches !== null ? row.total_catches : '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="distance">
      <th mat-header-cell *matHeaderCellDef>Distance</th>
      <td mat-cell *matCellDef="let row">
        {{ row.distance_miles !== null ? (row.distance_miles | number:'1.1-1') + ' mi' : '—' }}
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="clickable-row"
        (click)="viewReport(row.trip_id, $event)"></tr>
  </table>
  </div>
</div>
